module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-BOOSTER-GREEN-2.0d9f27ae.jpg";